import Uploader from './components/uploader/uploader.vue'
import UploaderBtn from './components/uploader/btn.vue'
import UploaderDrop from './components/uploader/drop.vue'
import UploaderUnsupport from './components/uploader/unsupport.vue'
import UploaderList from './components/uploader/list.vue'
import UploaderFiles from './components/uploader/files.vue'
import UploaderFile from './components/uploader/file.vue'

const uploader = {
  install,
  Uploader,
  UploaderBtn,
  UploaderDrop,
  UploaderUnsupport,
  UploaderList,
  UploaderFiles,
  UploaderFile
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(install)
}

export default uploader

function install (Vue) {
  if (install.installed) {
    return
  }
  Vue.component(Uploader.name, Uploader)
  Vue.component(UploaderBtn.name, UploaderBtn)
  Vue.component(UploaderDrop.name, UploaderDrop)
  Vue.component(UploaderUnsupport.name, UploaderUnsupport)
  Vue.component(UploaderList.name, UploaderList)
  Vue.component(UploaderFiles.name, UploaderFiles)
  Vue.component(UploaderFile.name, UploaderFile)
}
